module.exports = __webpack_public_path__ + "media/webfonts/fa-solid-900-d824df7e.woff2";